<template>
    <tr v-show="isVisible" :class="{'bg-red-200': !isConfigured}">
        <td class="px-6 py-3 whitespace-no-wrap ">

            <div :href="href" class="">
                <span v-show="user.is_admin"
                      class="mb-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">
                    Vollzugriff
                </span>
                <span v-show="user.is_sub_admin"
                      class="mb-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">
                    Teilzugriff
                </span>
                <span class="text-black no-underline block">
                    <span class="" :class="{'font-bold': matches(user.first_name)}">{{ user.first_name }}</span> <span
                    :class="{'font-bold': matches(user.name)}">{{ user.name }}</span><br>

                    <span class="text-gray-800" :class="{'font-bold': matches(user.email)}">
                        {{ user.email }}
                    </span><br/>

                    <span v-show="matches(user.personnel_number)" class="text-gray-800"
                          :class="{'font-bold': matches(user.personnel_number)}">
                        Personalnummer: {{ user.personnel_number }}<br>
                    </span>

                    <span v-show="matches(user.department)" class="text-gray-800"
                          :class="{'font-bold': matches(user.department)}">
                        Bereich: {{ user.department }}<br>
                    </span>

                    <span v-show="!isConfigured" class="text-red-700">User ist nicht konfiguriert.</span>
                </span>
            </div>

        </td>
        <td class="px-6 py-3">
            <span>{{ user.priority }}</span>
        </td>
        <td class="px-6 py-3">
            {{ user.user_groups.map(g => g.name).join(', ') }}
        </td>
        <td class="">
            <span v-if="user.desk">
                <a :href="'/admin/desks/' + user.desk.id"
                   class="block p-4 no-underline text-black hover:text-blue"
                   :class="{'font-bold': matches(desk)}">
                    {{ desk }}
                </a>
            </span>

        </td>
        <td class="px-6 py-3">
            {{ user.created_at | date }}
        </td>
        <td class="px-2 py-3">
            <a :href="'/admin/pages/user_access/' + user.id">
                <button-white>Zugriff</button-white>
            </a>
        </td>
        <td class="px-2 py-3">
            <a :href="'/admin/pages/users/' + user.id">
                <button-white>Bearbeiten</button-white>
            </a>
        </td>
    </tr>
</template>

<script>
import PermissionEdit from "./PermissionEdit";
import InputText from "./UI/InputText";
import UserEdit from "./UserEdit";
import get from "lodash/get";
import includes from "lodash/includes";
import format from "date-fns/format";
import ButtonPrimary from "./UI/ButtonPrimary.vue";
import ButtonLink from "./UI/ButtonLink.vue";
import ButtonWhite from "./UI/ButtonWhite.vue";

export default {
    components: {
        ButtonWhite,
        ButtonLink,
        ButtonPrimary,
        UserEdit,
        InputText,
        PermissionEdit,
    },

    inject: ['admin'],

    name: 'User',

    props: {
        user: {
            type: Object,
        },
        search: {
            type: String,
            default: '',
            required: true,
        },
    },
    data: () => ({
        edit: false,
        deskName: '',
    }),

    filters: {
        date(string) {
            if (string === undefined) {
                return '';
            }
            return format(new Date(string.substring(0, 10)), 'dd.MM.yyyy');
        },
    },

    computed: {
        isConfigured() {

            if (this.user.user_id === null) {
                return true;
            }

            if (this.user.desk_required.length === 0) {
                return false;
            }

            return this.user.is_configured;
        },
        searchField() {
            return [
                get(this.user, 'name', ''),
                get(this.user, 'first_name', ''),
                get(this.user, 'desk.name', ''),
                get(this.user, 'email', ''),
                get(this.user, 'department', ''),
                get(this.user, 'personnel_number', ''),
                get(this.user, 'user_groups', []).map(g => g.name).join(' '),
                //get(this.user, 'user_groups.name', ''),
            ].join(' ').toLowerCase();
        },
        isVisible() {
            if (this.search.length === 0) {
                return true;
            }

            return this.searchField.includes(this.search.toLowerCase());
        },

        href() {
            if (!this.user.id) {
                return '';
            }
            return '/admin/users/' + this.user.id;
        },

        desk: {
            get() {
                if (!this.user.desk) {
                    return '';
                }
                return this.user.desk.name;
            },
        },
    },

    methods: {
        reload() {
            this.$emit('reload');
        },
        matches(value) {
            if (value === undefined) {
                return false;
            }

            if (this.search.length === 0) {
                return false;
            }

            return includes(value.toLowerCase(), this.search.toLowerCase());
        },
    }
}
</script>

<style scoped>
</style>
